module.exports = __webpack_public_path__ + "assets/auryc.22bf9478.svg";